import React from 'react';

import { Box, Text } from '@betterment/samba-react';

import { BalanceDisclosureModal } from './AccountCard/BalanceDisclosureModal';
import {
  AllTimeGainsTimeWeightedReturns,
  AllTimeGainsTimeWeightedReturnsType,
} from './PerformanceGainsAndTimeWeightedReturns';

import { ENVELOPE_ACCOUNT_DIRECT_TRADING_TYPE, ENVELOPE_ACCOUNT_MANAGED_TYPE } from '../../../Shared/constants';
import urlBuilder from '../../../Shared/url-builder';
import { PerformanceDisclosure } from '../../PerformanceDisclosure/PerformanceDisclosure';
import { ImpersonationLink } from '../ImpersonationLink';

interface PerformanceProps extends AllTimeGainsTimeWeightedReturnsType {
  accountTypeName: string;
  legacyId?: string;
  asOf: string | null;
  clientId: string | undefined;
  directTradingBalanceDisclosure?: DocumentFragment;
  performanceDisclosure?: DocumentFragment;
}

export const AccountPerformanceDetails: React.FC<PerformanceProps> = ({
  accountTypeName,
  legacyId,
  allTimeGains,
  timeWeightedReturns,
  asOf,
  clientId,
  directTradingBalanceDisclosure,
  performanceDisclosure,
}) => {
  const isDirectTradingAccount = accountTypeName === ENVELOPE_ACCOUNT_DIRECT_TRADING_TYPE;
  const isManagedAccount = accountTypeName === ENVELOPE_ACCOUNT_MANAGED_TYPE;

  return (
    <Box>
      <AllTimeGainsTimeWeightedReturns
        allTimeGains={allTimeGains}
        isManagedAccount={isManagedAccount}
        timeWeightedReturns={timeWeightedReturns}
      />
      <Box css={{ mt: 'space.200' }}>
        {accountTypeName === ENVELOPE_ACCOUNT_MANAGED_TYPE && clientId && legacyId && (
          <ImpersonationLink
            showModal={true}
            url={urlBuilder.getImpersonateClientPage.absolute({
              clientId,
              deep_link_path: `/app/performance?settings[goal_ids][]=${legacyId}`,
            })}
            label="See performance details"
            variant="textPrimary"
          />
        )}
      </Box>
      <Box css={{ mt: 'space.300' }}>
        {isDirectTradingAccount && directTradingBalanceDisclosure && (
          <Text variant="text25" css={{ color: 'text.weak' }}>
            {asOf} <BalanceDisclosureModal disclosure={directTradingBalanceDisclosure} />.
          </Text>
        )}
        {isManagedAccount && asOf && performanceDisclosure && (
          <Box css={{ mt: 'space.200' }}>
            <PerformanceDisclosure asOf={asOf} performanceDisclosure={performanceDisclosure} />
          </Box>
        )}
      </Box>
    </Box>
  );
};
